// hallenbild.js — Foto eines Starters auf einem Hallenbildschirm (21.10.2026)
//
// Formen- und Siegerehrungs-Leinwand bekommen vom Panel bzw. Server nie den
// Pfad des Fotos, nur `foto_frei` (Einwilligung liegt vor, eigene Datei) und
// die wettkaempfer_id. Das Bild holt der Bildschirm mit SEINEM Hallenschlüssel
// (k= in der eigenen Adresse) über GET /api/hallenbild/:turnier/:wettkaempfer?k=
// (backend/routes/hallenbild.js). Die Route prüft Schlüssel, Meldung und
// Einwilligung selbst; ohne gültigen Schlüssel kommt nichts.
// Gleiche Form wie backend/utils/fotoFreigabe.js (hallenbildAdresse).

/** Adresse der geprüften Bildroute oder null */
export function hallenbildAdresse(turnierId, wettkaempferId, schluessel) {
  const t = Number(turnierId);
  const w = Number(wettkaempferId);
  if (!(t > 0) || !(w > 0) || !/^[0-9a-f]{16,64}$/.test(String(schluessel || ''))) return null;
  return `/api/hallenbild/${t}/${w}?k=${schluessel}`;
}

/** Foto eines Starters für diesen Bildschirm (halle = { turnierId, k }), sonst null */
export function hallenFoto(person, halle) {
  if (!person || !person.foto_frei || !halle) return null;
  return hallenbildAdresse(halle.turnierId, person.wettkaempfer_id, halle.k);
}
